import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';

export const useGetAdultRating = () => {
  const keyByRegion = useSelector(
    selectMetadataKeyByRegion('adult_channel_rating'),
  );
  const { rating_code, parental_rating } = keyByRegion;

  const isAdultRateEvent = eventParentalRating => {
    if (Array.isArray(eventParentalRating) && eventParentalRating[0])
      return eventParentalRating[0]?.code === rating_code;
    if (eventParentalRating) return eventParentalRating === parental_rating;
    else return false;
  };

  return {
    rating_code,
    parental_rating,
    isAdultRateEvent,
  };
};
